angular.module('unica_invitation_transfer.invitation_transfer_controllers', []);